import { useStore } from "@priolo/jon";
import CropIcon from "images/menu/crop";
import React, { FunctionComponent, memo, useEffect, useMemo, useState } from "react";
import farmSo from "stores/farm";
import cropRecipeSo from "stores/library/cropRecipe";
import { getItemsFiltered } from "stores/tag/utils";
import { Crop } from "types/Crop";
import MultiSelectorDialogBase2 from "../base/MultiSelectorDialogBase2";
import Chip from "./Chip";




type Props = {
	sx?: any
	/** i CROP selezionati */
	cropIds: number[],
	/** quando si selezionano i CROP */
	onChange: (cropIds: number[]) => void,
}

/**
 * permette la selezione multipla dei CROP-RECIPE
 */
const SelectorCropsH: FunctionComponent<Props> = ({
	cropIds,
	onChange,
	sx,
}) => {

	// STORE
	useStore(cropRecipeSo)

	// HOOKs
	const [isOpen, setIsOpen] = useState(false)
	const [textFilter, setTextFilter] = useState("")

	useEffect(() => {
		cropRecipeSo.fetchAllIfVoid()
	}, [])

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (selectedIds: number[]) => {
		setIsOpen(false)
		if (!selectedIds) return
		onChange?.(selectedIds)
	}
	const handleClear = (e: React.MouseEvent) => {
		e.stopPropagation()
		setIsOpen(false)
		onChange?.([])
	}

	// RENDER
	const crops = useMemo(() => {
		return getItemsFiltered(
			cropRecipeSo.state.all, 
			{ txt: textFilter, farmId: farmSo.state.select?.id }
		)
	}, [cropRecipeSo.state.all, textFilter])

	const cropsSelect = useMemo(
		() => (cropIds ?? []).map(id => cropRecipeSo.getById(id)).filter(Boolean),
		[cropRecipeSo.state.all, cropIds]
	)
	const label = useMemo(() => {
		if (cropsSelect.length == 0) return "ALL CROPS"
		if (cropsSelect.length == 1) return cropsSelect[0].name
		if (cropsSelect.length == 2) return cropsSelect.map(crop => crop.name).join(", ")
		return `${cropsSelect.length} CROPS`
	}, [cropsSelect])

	if ( !cropRecipeSo.state.all ) return null

	return (<>
		<Chip sx={sx}
			label={label}
			icon={<CropIcon width={18} height={18} />}
			tooltip={"FILTER ON CROP"}
			active={cropsSelect.length > 0}
			onClick={handleClick}
			onClear={handleClear}
		/>
		<MultiSelectorDialogBase2
			title={"CROP VISIBLE"}
			width="auto"
			height={600}
			icon={<CropIcon />}

			items={crops}
			itemsSelect={cropIds ?? []}
			textValue={textFilter}
			isOpen={isOpen}

			onClose={handleClose}
			onChangeTextValue={txt => setTextFilter(txt)}

			fnTextFromItem={(item: Crop) => item?.name}
			fnIdFromItem={item => item.id}
		/>
	</>)
}

export default memo(SelectorCropsH, (oldProps, newProps) => {
	const oldIds = oldProps.cropIds ?? []
	const newIds = newProps.cropIds ?? []
	if (oldIds.length !== newIds.length) return false
	if (oldIds.some((currentId, index) => currentId !== newIds[index])) return false
	return oldProps.onChange === newProps.onChange && oldProps.sx === newProps.sx
})
